import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "app/app";
import { setupDecimal } from "shared/utils";

import "react-loading-skeleton/dist/skeleton.css";

import "./app/index.css";

setupDecimal();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
